import React, { useEffect, useRef, useState } from "react";
import Pagination from "../../components/Pagination/Pagination";
import CheckboxDropDown from "../../components/CheckboxDropDown/CheckboxDropDown";
import Search from "../../components/SearchBar/Search";
import NoResultsComponent from "../../components/NoResults/NoResult";
import Loader from "../../components/Loader/Loader";
import CryptoUtils from "../../util/cryptoUtils";
import { useRole } from "../../context/Rolecontext";
import {
  DownloadAuditTrail,
  fetch_All_AuditTrail_Briefs,
  fetch_All_AuditTrail_Proposals,
  fetchFilterActions,
  fetchFilterClusters,
} from "../../services/auditTrailAPI";
import { useCluster } from "../ClusterContext/ClusterContext";
import "./AuditTrail.css";
import AuditTrailTable from "../../components/Table/AuditTrailTable";
import DatePickerDropdown from "../../components/DatePicker/DatePicker";
import Toast from "../../components/Toast/Toast";
import { useLocation } from "react-router-dom";
import { useLanguage } from "../../context/Languagecontext";
import { Globals as OldGlobals } from "../../global/Globals";


let paginationPageChange = () => { };
const AuditTrail = () => {
  const location = useLocation();
  const { Globals, languages, setLanguages } = useLanguage();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState(null);
  const [roleID, setroldId] = useState(CryptoUtils.getFromLocalStorage("roleId")?.toString());
  const [dataSorting, setDatasorting] = useState(1);
  const [auditTrailstatus, setauditTrailstatus] = useState(null);
  const isInitialRenderPage = useRef(true);
  const isInitialRenderSort = useRef(true);
  const isInitialRenderDropdown = useRef(true);
  const isInitialRenderSearch = useRef(true);
  const isIntialRenderRole = useRef(true);
  const isInitialRenderDate = useRef(true);
  const isInitialLanguage = useRef(true);
  const dropdownRefs = useRef({}); // Store refs for dropdowns
  const prevSelectedState = useRef({});
  const { selectedClusters } = useCluster();
  const { selectedRole } = useRole();
  const [AuditTrailData, setAuditTrailData] = useState(null);
  const [AuditTrailCount, setAuditTrailCount] = useState(null);
  const [activeTab, setActiveTab] = useState(OldGlobals.AUDITTRAIL.PROPOSALS);
  const [clusterId, setClusterId] = useState();
  const [clusterName, setClusterName] = useState();
  const [enableClearAll, setEnableClearAll] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(false);
  const [toast, setToast] = useState({ open: false, status: '', title: "" });
  const [isExcelDownloading, setIsExcelDownloading] = useState(null);

  function formatDateToYYYYMMDD(date) {
    return new Date(date).toISOString().split("T")[0];
  }

  const getDateMonthsBack = (date, months) => {
    const d = new Date(date);
    d.setMonth(d.getMonth() - months);
    return d.toISOString().split("T")[0];
  };

  const getDateMonthsAfter = (date, months) => {
    const d = new Date(date);
    d.setMonth(d.getMonth() + months);
    return d.toISOString().split("T")[0];
  };

  const getDateDaysBack = (date, days) => {
    const d = new Date(date);
    d.setDate(d.getDate() - days);
    return formatDateToYYYYMMDD(d);
  };

  function getDateDaysAfter(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  const today = new Date();
  const initialFromDate = getDateMonthsBack(today, 3);

  const [fromDate, setFromDate] = useState(initialFromDate);
  const [toDate, setToDate] = useState(today.toISOString().split("T")[0]);

  const minFromDate = "2000-01-01";
  const maxFromDate = today.toISOString().split("T")[0];

  const minToDate = fromDate;
  const maxToDate = today.toISOString().split("T")[0];

  const [dropdownState, setDropdownState] = useState({
    activeDropdown: null,
    dropdowns: {
      ACTIONBY: { options: [], selected: [], selectedText: [], isloading: false },
      CLUSTER: { options: [], selected: [], selectedText: [], isloading: false },
    },
  });
  const [isClearAllTriggered, setIsClearAllTriggered] = useState(false);
  const [dateError, setDateError] = useState(null);

  // Utility: Checks whether the 180-day range is valid
  const isValid180DayRange = (start, end) => {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const diffInMs = endDate - startDate;
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
    return diffInDays >= 0 && diffInDays <= 180;
  };

  const handleFromDateChange = (name, value) => {
    if (toDate && !isValid180DayRange(value, toDate)) {
      setFromDate(value);
      setDateError(Globals.AUDITTRAIL.DATE_180DAYSERROR);
      setEnableClearAll(true);
    } else {
      setFromDate(value);
      setDateError(null);
      setEnableClearAll(true);
    }
  };

  const handleToDateChange = (name, value) => {
    if (fromDate && !isValid180DayRange(fromDate, value)) {
      setToDate(value);
      setDateError(Globals.AUDITTRAIL.DATE_180DAYSERROR);
      setEnableClearAll(true);
    } else {
      setToDate(value);
      setDateError(null); // clear error if valid
      setEnableClearAll(true);
    }

  };

  const renderToast = (status, title) => {
    setToast({ open: true, status: status, title: title });
    setTimeout(() => {
      setToast({ open: false, status: '', title: '' });
    }, 4000);
  }


  //Functionality for the OnPageChange
  const onPageChange = (pageNumber, setPage = () => { }) => {
    setCurrentPage(pageNumber);
    paginationPageChange = setPage;
  };

  //Functionality for the TabChange
  const handleTabClick = (tab) => {
    setauditTrailstatus(null);
    setAuditTrailData(null);
    setAuditTrailCount(null);
    setDateError(null);
    resetToIntitialDate();
    handleClearAll();
    fetchOptions("ACTIONBY");
    setFromDate(initialFromDate);
    setToDate(today.toISOString().split("T")[0]);
    setDropdownState((prev) => {
      const clearedDropdowns = Object.keys(prev.dropdowns).reduce((acc, key) => {
        acc[key] = { ...prev.dropdowns[key], options: [] };
        if (prev.dropdowns[key].hasOwnProperty("selectedMonthYear")) {
          acc[key].selectedMonthYear = [];
        }
        return acc;
      }, {});
      return { ...prev, dropdowns: clearedDropdowns };
    });
    setActiveTab(tab);
    const data = {
      actionBy: dropdownState.dropdowns.ACTIONBY.selected,
      fromDate: fromDate ? formatDateToYYYYMMDD(fromDate) : "",
      toDate: toDate ? formatDateToYYYYMMDD(toDate) : "",
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
      clusterId:
        roleID === OldGlobals.USER_ROLES.SNR_MGR || roleID === OldGlobals.USER_ROLES.HOP || roleID === OldGlobals.USER_ROLES.CC || roleID === OldGlobals.USER_ROLES.CE
          ? [clusterId]
          : roleID === OldGlobals.USER_ROLES.ADMIN
            ? dropdownState.dropdowns.CLUSTER.selected
            : null,
    };
    paginationPageChange(1);
    fetchAllAuditTrails(data, 1, tab);
  };

  useEffect(() => {
    if (isIntialRenderRole.current) {
      isIntialRenderRole.current = false;
      return; // Skip on first render
    }
    setDropdownState((prev) => {
      const clearedDropdowns = Object.keys(prev.dropdowns).reduce((acc, key) => {
        acc[key] = { ...prev.dropdowns[key], options: [], selected: [], selectedText: [] };
        if (prev.dropdowns[key].hasOwnProperty("selectedMonthYear")) {
          acc[key].selectedMonthYear = [];
        }
        return acc;
      }, {});
      return { ...prev, dropdowns: clearedDropdowns };
    });
    setauditTrailstatus(null);
    setAuditTrailData(null);
    setAuditTrailCount(null);
    setDateError(null);
    setFromDate(initialFromDate);
    setToDate(today.toISOString().split("T")[0]);
    const data = {
      actionBy: dropdownState.dropdowns.ACTIONBY.selected,
      fromDate: fromDate ? formatDateToYYYYMMDD(fromDate) : "",
      toDate: toDate ? formatDateToYYYYMMDD(toDate) : "",
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
      clusterId:
        roleID === OldGlobals.USER_ROLES.SNR_MGR || roleID === OldGlobals.USER_ROLES.HOP  ||  roleID === OldGlobals.USER_ROLES.CC || roleID === OldGlobals.USER_ROLES.CE
          ? [clusterId]
          : roleID === OldGlobals.USER_ROLES.ADMIN
            ? dropdownState.dropdowns.CLUSTER.selected
            : null,
    };
    fetchAllAuditTrails(data, 1, activeTab);
  }, [roleID]);

  useEffect(() => {
    if (searchQuery !== null) {
      setEnableClearAll(true);
    }
    const data = {
      actionBy: dropdownState.dropdowns.ACTIONBY.selected,
      fromDate: fromDate ? formatDateToYYYYMMDD(fromDate) : "",
      toDate: toDate ? formatDateToYYYYMMDD(toDate) : "",
      search: searchQuery ? searchQuery : null,
      filter: dataSorting,
      clusterId:
        roleID === OldGlobals.USER_ROLES.SNR_MGR || roleID === OldGlobals.USER_ROLES.HOP ||  roleID === OldGlobals.USER_ROLES.CC || roleID === OldGlobals.USER_ROLES.CE
          ? [clusterId]
          : roleID === OldGlobals.USER_ROLES.ADMIN
            ? dropdownState.dropdowns.CLUSTER.selected
            : null,
    };
    if (clusterId && clusterName) {
      paginationPageChange(1);
      fetchAllAuditTrails(data, 1, activeTab);
      fetchOptions("ACTIONBY");
    } else if (roleID === "1") {
      paginationPageChange(1);
      fetchAllAuditTrails(data, 1, activeTab);
      fetchOptions("ACTIONBY");
    }

  }, [clusterId, clusterName]);

  useEffect(() => {
    const initialCluster = JSON.parse(CryptoUtils.getFromLocalStorage("clusterName"));
    if (initialCluster?.length > 0) {
      setClusterId(initialCluster[0].clusterId);
      setClusterName(initialCluster[0].clusterName);
    }
  }, []);

  //cluster Change logic
  useEffect(() => {
    const newCluster = JSON.parse(CryptoUtils.getFromLocalStorage("clusterName"));
    setDropdownState((prev) => {
      const clearedDropdowns = Object.keys(prev.dropdowns).reduce((acc, key) => {
        acc[key] = { ...prev.dropdowns[key], options: [] };
        if (prev.dropdowns[key].hasOwnProperty("selectedMonthYear")) {
          acc[key].selectedMonthYear = [];
        }
        return acc;
      }, {});
      return { ...prev, dropdowns: clearedDropdowns };
    });
    if (newCluster) {
      setClusterId(newCluster[0].clusterId);
      setClusterName(newCluster[0].clusterName);
    }
  }, [selectedClusters]);

  //Role Change logic
  useEffect(() => {
    if (clusterId) {
      setroldId(CryptoUtils.getFromLocalStorage("roleId")?.toString());
    }
  }, [selectedRole]);

  // Functionality for DropDownchange
  useEffect(() => {
    if (isInitialRenderDropdown.current) {
      isInitialRenderDropdown.current = false;
      prevSelectedState.current = Object.fromEntries(
        Object.entries(dropdownState.dropdowns).map(([key, value]) => [key, value.selected])
      );
      return;
    }

    let hasSelectedChanged = false;

    for (const key of Object.keys(dropdownState.dropdowns)) {
      const currentSelected = dropdownState.dropdowns[key]?.selected || [];
      const prevSelected = prevSelectedState.current[key] || [];

      if (JSON.stringify(currentSelected) !== JSON.stringify(prevSelected)) {
        hasSelectedChanged = true;
        break;
      }
    }

    if (!hasSelectedChanged && !isClearAllTriggered) return;

    const hasSelectedOptions = Object.values(dropdownState.dropdowns).some(
      (dropdown) => dropdown?.selected?.length > 0
    );

    setEnableClearAll(hasSelectedOptions || !!searchQuery);

    const data = {
      actionBy: dropdownState.dropdowns.ACTIONBY.selected,
      fromDate: fromDate ? formatDateToYYYYMMDD(fromDate) : "",
      toDate: toDate ? formatDateToYYYYMMDD(toDate) : "",
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
      clusterId:
        roleID === OldGlobals.USER_ROLES.SNR_MGR || roleID === OldGlobals.USER_ROLES.HOP || roleID === OldGlobals.USER_ROLES.CC || roleID === OldGlobals.USER_ROLES.CE
          ? [clusterId]
          : roleID === OldGlobals.USER_ROLES.ADMIN
            ? dropdownState.dropdowns.CLUSTER.selected
            : null,
    };

    paginationPageChange(1);
    fetchAllAuditTrails(data, 1, activeTab);

    // Update only selected values in ref
    prevSelectedState.current = Object.fromEntries(
      Object.entries(dropdownState.dropdowns).map(([key, value]) => [key, value.selected])
    );
    fetchOptions("ACTIONBY");
    if (isClearAllTriggered) setIsClearAllTriggered(false);
  }, [dropdownState, isClearAllTriggered]);

  // Functionality for PageChange
  useEffect(() => {
    if (isInitialRenderPage.current) {
      isInitialRenderPage.current = false;
      return; // Skip on first render
    }

    const data = {
      actionBy: dropdownState.dropdowns.ACTIONBY.selected,
      fromDate: fromDate ? formatDateToYYYYMMDD(fromDate) : "",
      toDate: toDate ? formatDateToYYYYMMDD(toDate) : "",
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
      clusterId:
        roleID === OldGlobals.USER_ROLES.SNR_MGR || roleID === OldGlobals.USER_ROLES.HOP || roleID === OldGlobals.USER_ROLES.CC || roleID === OldGlobals.USER_ROLES.CE
          ? [clusterId]
          : roleID === OldGlobals.USER_ROLES.ADMIN
            ? dropdownState.dropdowns.CLUSTER.selected
            : null,
    };
    fetchAllAuditTrails(data, currentPage, activeTab);
  }, [currentPage]);

  // Functionality for SearchChange
  useEffect(() => {
    if (isInitialRenderSearch.current) {
      isInitialRenderSearch.current = false;
      return; // Skip on first render
    }
    setAuditTrailData(null);
    const data = {
      actionBy: dropdownState.dropdowns.ACTIONBY.selected,
      fromDate: searchQuery ? "" : fromDate ? formatDateToYYYYMMDD(fromDate) : "",
      toDate: searchQuery ? "" : toDate ? formatDateToYYYYMMDD(toDate) : "",
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
      clusterId:
        roleID === OldGlobals.USER_ROLES.SNR_MGR || roleID === OldGlobals.USER_ROLES.HOP || roleID === OldGlobals.USER_ROLES.CC || roleID === OldGlobals.USER_ROLES.CE
          ? [clusterId]
          : roleID === OldGlobals.USER_ROLES.ADMIN
            ? dropdownState.dropdowns.CLUSTER.selected
            : null,
    };

    paginationPageChange(1);
    fetchAllAuditTrails(data, 1, activeTab);
  }, [searchQuery]);

  // Functionality for sorting
  useEffect(() => {
    if (isInitialRenderSort.current) {
      isInitialRenderSort.current = false;
      return; // Skip on first render
    }
    const data = {
      actionBy: dropdownState.dropdowns.ACTIONBY.selected,
      fromDate: fromDate ? formatDateToYYYYMMDD(fromDate) : "",
      toDate: toDate ? formatDateToYYYYMMDD(toDate) : "",
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
      clusterId:
        roleID === OldGlobals.USER_ROLES.SNR_MGR || roleID === OldGlobals.USER_ROLES.HOP || roleID === OldGlobals.USER_ROLES.CC || roleID === OldGlobals.USER_ROLES.CE
          ? [clusterId]
          : roleID === OldGlobals.USER_ROLES.ADMIN
            ? dropdownState.dropdowns.CLUSTER.selected
            : null,
    };
    fetchAllAuditTrails(data, currentPage, activeTab);
  }, [dataSorting]);

  //From Date Side Effects
  useEffect(() => {
    if (isInitialRenderDate.current) {
      isInitialRenderDate.current = false;
      return; // Skip on first render
    }
    setAuditTrailData(null);
    const data = {
      actionby: dropdownState.dropdowns.ACTIONBY.selected,
      fromDate: fromDate ? formatDateToYYYYMMDD(fromDate) : "",
      toDate: toDate ? formatDateToYYYYMMDD(toDate) : "",
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
      clusterId:
        roleID === OldGlobals.USER_ROLES.SNR_MGR || roleID === OldGlobals.USER_ROLES.HOP || roleID === OldGlobals.USER_ROLES.CC || roleID === OldGlobals.USER_ROLES.CE
          ? [clusterId]
          : roleID === OldGlobals.USER_ROLES.ADMIN
            ? dropdownState.dropdowns.CLUSTER.selected
            : null,
    };
    if (dateError === null) {
      fetchAllAuditTrails(data, 1, activeTab);
    }
  }, [fromDate, toDate]);

  //Api calling for the Proposal and Brief AuditTrails
  async function fetchAllAuditTrails(filters, pagenumber, activetab) {
    try {
      let responseData;
       setauditTrailstatus(null);
      if (activetab === OldGlobals.AUDITTRAIL.PROPOSALS) {
        responseData = await fetch_All_AuditTrail_Proposals(filters, pagenumber, roleID);
        setAuditTrailData(responseData?.data?.content?.proposals);
        setAuditTrailCount(responseData?.data?.content?.pageCount);
        setauditTrailstatus(responseData.data.status);
      } else if (activetab === OldGlobals.AUDITTRAIL.BRIEFS) {
        responseData = await fetch_All_AuditTrail_Briefs(filters, pagenumber, roleID);
        setAuditTrailData(responseData?.data?.content?.proposals);
        setAuditTrailCount(responseData?.data?.content?.pageCount);
        setauditTrailstatus(responseData.data.status);
      }
    } catch (error) {
      console.error("Error in fetching brief info", error);
    }
  }

  async function exportProposalsBrief(filters, activetab) {
    try {
      setIsExcelDownloading(activetab);
      const Response = await DownloadAuditTrail(filters, activetab);
      const exportName = activeTab === "Proposal Audit Trail" ? "AuditTrailProposals.xlsx" : "AuditTrailBriefs.xlsx";
      if (Response?.data) {
        const base64 = Response?.data?.content;
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const fileUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = exportName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(fileUrl);
        setIsExcelDownloading(null);
      }
      else {
        console.error("Error: No file data available for download.");
        setIsExcelDownloading(null);
      }
    }
    catch (error) {
      console.error("Error in Exporting", error);
    }
  }

  //Functionality for the ClickOutside Dropdown
  const handleClickOutside = (event) => {
    const isClickInsideDropdown = Object.values(dropdownRefs.current).some((ref) =>
      ref?.contains(event.target)
    );

    if (!isClickInsideDropdown) {
      setActiveDropdown(null);
    }
  };

  //Listners for Mousedown
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  //Functionality for opening dropdowns the Channel, CreatedBy, Producer, Status
  const handletog = async (dropdownName) => {
    setActiveDropdown((prev) => (prev === dropdownName ? null : dropdownName));
    paginationPageChange(1);

    if (
      dropdownState.dropdowns[dropdownName]?.options &&
      dropdownState.dropdowns[dropdownName]?.options.length === 0
    ) {
      await fetchOptions(dropdownName);
    }
  };

  //Functionality for the fetching options Channel, CreatedBy, Producer, Status
  const fetchOptions = async (dropdownName) => {
    setDropdownState((prev) => ({
      ...prev,
      dropdowns: {
        ...prev.dropdowns,
        [dropdownName]: { ...prev.dropdowns[dropdownName], isLoading: true },
      },
    }));

    try {
      let response;
      let filterData;
      if (dropdownName === "ACTIONBY") {
        roleID === "1"
          ? (response = await fetchFilterActions(roleID, dropdownState.dropdowns.CLUSTER.selected))
          : (response = await fetchFilterActions(roleID, [clusterId]));
        filterData = response.data.actionBy;
      } else if (dropdownName == "CLUSTER") {
        response = await fetchFilterClusters();
        filterData = response.data.clusteInfo;
      }
      // Simulate fetching options for each dropdown
      setDropdownState((prev) => ({
        ...prev,
        dropdowns: {
          ...prev.dropdowns,
          [dropdownName]: {
            ...prev.dropdowns[dropdownName],
            options: [...filterData],
            isLoading: false,
          },
        },
      }));
    } catch (error) {
      console.error("Error fetching options:", error);
      setDropdownState((prev) => ({
        ...prev,
        dropdowns: {
          ...prev.dropdowns,
          [dropdownName]: { ...prev.dropdowns[dropdownName], isLoading: false },
        },
      }));
    }
  };

  //Functionality for the SelectAll
  const handleSelectAll = (dropdownName, selectAll, options) => {
    setauditTrailstatus(null);
    const selectedDataSting = options.map((option) => String(option.id));
    const selectedDataText = options.map((option) => String(option.name));

    setDropdownState((prev) => ({
      ...prev,
      dropdowns: {
        ...prev.dropdowns,
        [dropdownName]: {
          ...prev.dropdowns[dropdownName],
          selected: selectAll ? selectedDataSting : [],
          selectedText: selectAll ? selectedDataText : [],
        },
      },
    }));
  };

  //Functionality for the Select
  const handleSelect = (dropdownName, value) => {
    setauditTrailstatus(null);
    setDropdownState((prev) => {
      const dropdown = prev.dropdowns[dropdownName];
      if (!dropdown) return prev;
      const isSelected = dropdown.selected.includes(String(value.id));
      const inSelectedText = dropdown.selectedText.includes(String(value.name));

      const newSelected = isSelected
        ? dropdown.selected.filter((item) => item !== String(value.id)).map(String)
        : [...dropdown.selected.filter((item) => item !== String(value.id)), String(value.id)];

      const newSelectedText = inSelectedText
        ? dropdown.selectedText.filter((item) => item !== String(value.name)).map(String)
        : [
          ...dropdown.selectedText.filter((item) => item !== String(value.name)),
          String(value.name),
        ];

      return {
        ...prev,
        dropdowns: {
          ...prev.dropdowns,
          [dropdownName]: {
            ...dropdown,
            selected: newSelected,
            selectedText: newSelectedText,
          },
        },
      };
    });
  };

  //Set InitialDate on ClearAll
  const resetToIntitialDate = () => {
    setFromDate(initialFromDate);
    setToDate(today.toISOString().split("T")[0]);
  }

  //Functionality for the ClearAll
  const handleClearAll = () => {
    if (enableClearAll) {
      setCurrentPage(1);
      setEnableClearAll(false);
      setauditTrailstatus(null);
      setAuditTrailData(null);
      resetToIntitialDate();
      setSearchQuery(null);
      setDropdownState((prev) => {
        const clearedDropdowns = Object.keys(prev.dropdowns).reduce((acc, key) => {
          acc[key] = { ...prev.dropdowns[key], selected: [], selectedText: [] };
          if (prev.dropdowns[key].hasOwnProperty("selectedMonthYear")) {
            acc[key].selectedMonthYear = [];
          }
          return acc;
        }, {});
        return { ...prev, dropdowns: clearedDropdowns };
      });
      setIsClearAllTriggered(true);
    }
  };

  //Functionality for the Search
  const handleSearch = (term) => {
    setSearchQuery(term);
    const dropdownSelected = Object.values(dropdownState?.dropdowns || {}).some(
      (dropdown) => dropdown?.selected?.length > 0
    );
    setauditTrailstatus(null);
    setEnableClearAll(term !== "" || dropdownSelected);
  };

  //Functionality for the Sorting
  const handleSorting = (sorting) => {
    setDatasorting(sorting);
  };

  const ExportProposalsbriefs = () => {
    const data = {
      actionBy: dropdownState.dropdowns.ACTIONBY.selected,
      fromDate: fromDate ? formatDateToYYYYMMDD(fromDate) : "",
      toDate: toDate ? formatDateToYYYYMMDD(toDate) : "",
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
      clusterId:
        roleID === OldGlobals.USER_ROLES.SNR_MGR || roleID === OldGlobals.USER_ROLES.HOP || roleID === OldGlobals.USER_ROLES.CC || roleID === OldGlobals.USER_ROLES.CE
          ? [clusterId]
          : roleID === OldGlobals.USER_ROLES.ADMIN
            ? dropdownState.dropdowns.CLUSTER.selected
            : null,
    };
    if (dateError === null) {
      exportProposalsBrief(data, activeTab);
    }

  }

  const dropdownselected = Object.values(dropdownState?.dropdowns).some(
    (dropdown) => dropdown?.selected && dropdown?.selected.length > 0
  );
  //Language changes
  useEffect(() => {
    if (isInitialLanguage.current) {
      isInitialLanguage.current = false;
      return; // Skip on first render
    }

    setDropdownState((prev) => {
      const clearedDropdowns = Object.keys(prev.dropdowns).reduce((acc, key) => {
        acc[key] = { ...prev.dropdowns[key], selected: [], selectedText: [], options: [] };
        return acc;
      }, {});
      return { ...prev, dropdowns: clearedDropdowns };
    });
    const data = {
      actionBy: dropdownState.dropdowns.ACTIONBY.selected,
      fromDate: fromDate ? formatDateToYYYYMMDD(fromDate) : "",
      toDate: toDate ? formatDateToYYYYMMDD(toDate) : "",
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
      clusterId:
        roleID === OldGlobals.USER_ROLES.SNR_MGR || roleID === OldGlobals.USER_ROLES.HOP ||  roleID === OldGlobals.USER_ROLES.CC || roleID === OldGlobals.USER_ROLES.CE
          ? [clusterId]
          : roleID === OldGlobals.USER_ROLES.ADMIN
            ? dropdownState.dropdowns.CLUSTER.selected
            : null,
    };
    paginationPageChange(1);
    fetchAllAuditTrails(data, 1, activeTab);
    fetchOptions("ACTIONBY");
  }, [languages]);

  return (
    <>
      <div className="Audit_Trail">
        <div className="auditTrail-content-box">
          <div className="auditTrail-overview-tabs">
            <div className="active-inactive-tabs">
              <div
                className={`proposal-overview-tab ${activeTab === OldGlobals.AUDITTRAIL.PROPOSALS ? "active" : ""
                  }`}
                onClick={() => handleTabClick(OldGlobals.AUDITTRAIL.PROPOSALS)}
              >
                {Globals.AUDITTRAIL.PROPOSALS}
              </div>
              <div
                className={`proposal-overview-tab ${activeTab === OldGlobals.AUDITTRAIL.BRIEFS ? "active" : ""
                  }`}
                onClick={() => handleTabClick(OldGlobals.AUDITTRAIL.BRIEFS)}
              >
                {Globals.AUDITTRAIL.BRIEFS}
              </div>
            </div>
            <div className="auditTrail-top-seperater"></div>
          </div>

          <div className="filters">
            <div className="filterHeading">{Globals.PRODUCER.FILTERBY}</div>

            {(searchQuery === null || searchQuery === "") && <DatePickerDropdown
              inputLabel={null}
              placeholderText="From"
              name="From"
              disabled={false}
              minDate={minFromDate}
              maxDate={maxFromDate}
              onDateChange={handleFromDateChange}
              selectedDate={fromDate}
              label={Globals.FROM}
              error={dateError}
            />}

            {(searchQuery === null || searchQuery === "") && <DatePickerDropdown
              inputLabel={null}
              placeholderText="To"
              name="To"
              disabled={false}
              minDate={minToDate}
              maxDate={maxToDate}
              onDateChange={handleToDateChange}
              selectedDate={toDate}
              label={Globals.TO}
              error={dateError}
            />}

            <CheckboxDropDown
              isOpen={activeDropdown === "ACTIONBY"}
              options={dropdownState.dropdowns.ACTIONBY.options}
              onToggle={() => handletog("ACTIONBY")}
              onSelectAll={(selectAll, options) => handleSelectAll("ACTIONBY", selectAll, options)}
              isDatePicker={false}
              onSelect={(value) => {
                handleSelect("ACTIONBY", value);
              }}
              selectedValues={dropdownState.dropdowns.ACTIONBY.selected}
              title={Globals.AUDITTRAIL.FILTERACTIONBY}
              dropdownRef={(el) => (dropdownRefs.current["ActionBy"] = el)}
              selectedItems={dropdownState.dropdowns.ACTIONBY.selectedText}
              isCreatedBy={true}
            />

            {roleID === OldGlobals.USER_ROLES.ADMIN && (
              <CheckboxDropDown
                isOpen={activeDropdown === "CLUSTER"}
                options={dropdownState.dropdowns.CLUSTER.options}
                onToggle={() => handletog("CLUSTER")}
                onSelectAll={(selectAll, options) => handleSelectAll("CLUSTER", selectAll, options)}
                isDatePicker={false}
                onSelect={(value) => {
                  handleSelect("CLUSTER", value);
                }}
                selectedValues={dropdownState.dropdowns.CLUSTER.selected}
                title={Globals.AUDITTRAIL.FILTERCLUSTER}
                dropdownRef={(el) => (dropdownRefs.current["Cluster"] = el)}
                selectedItems={dropdownState.dropdowns.CLUSTER.selectedText}
              />
            )}

            <div
              className={enableClearAll ? "clear clearAllEnable" : "clear"}
              onClick={() => handleClearAll()}
            >
              {Globals.PRODUCER.CLEARALL}
            </div>

            <div className="AuditTrail_search">
              <Search
                onSearch={handleSearch}
                searchedFor={searchQuery}
                placeholder={
                  activeTab === OldGlobals.AUDITTRAIL.PROPOSALS
                    ? Globals.AUDITTRAIL.SEARCH_PROPOSALS
                    : Globals.AUDITTRAIL.SEARCH_BRIEF
                }
              />
              <div className="DownloadExcel" onClick={() => { ExportProposalsbriefs() }}>
                <img width={40} height={40} src={isExcelDownloading !== null ? OldGlobals.LOADERS.SPINNING_LOADER : OldGlobals.IMG.DOWNLOAD_EXCEL} />
              </div>
            </div>
          </div>

          <div className="Table_data">
            {dateError === null ? (
              AuditTrailData && AuditTrailData.length > 0 ? (
                <AuditTrailTable
                  data={AuditTrailData}
                  onSort={handleSorting}
                  activeTab={activeTab}
                  key={activeTab}
                  sortKey={dataSorting}
                  currentPage={currentPage}
                />
              ) : auditTrailstatus && auditTrailstatus.length > 0 ? (
                <div className="no-data">
                  <NoResultsComponent
                    data={{
                      message:
                        dropdownselected || (searchQuery && searchQuery.length > 0)
                          ? Globals.NO_RESULTS_MESSAGE
                          : Globals.NO_DATA_WITHOUTFILTER,
                      img:
                        dropdownselected || (searchQuery && searchQuery.length > 0)
                          ? OldGlobals.NO_RESULTS_IMG
                          : OldGlobals.NO_DATA_FOUND_IMG,
                      submessage:
                        dropdownselected || (searchQuery && searchQuery.length > 0)
                          ? Globals.NO_RESULTS_SUBMESSAGE
                          : "",
                    }}
                  />
                </div>
              ) : (
                <Loader height={50} width={50} component={"AuditTrail"} />
              )
            ) : <div className="DateErrorAuditTrail">{Globals.AUDITTRAIL.DATE_180DAYSERROR}</div >}
          </div>
          <div className="pagination-container">
            {dateError === null ? (
              AuditTrailData && AuditTrailData.length > 0 ? (
                <Pagination
                  totalPages={Math.ceil(AuditTrailCount / Globals.MAX_COUNT.TABLE_DATA_COUNT)}
                  currentPage={currentPage}
                  onPageChange={onPageChange}
                />
              ) : (
                ""
              )
            ) :
              <></>}
          </div>
        </div>
        {toast.open && <Toast status={toast.status} onClose={() => { setToast({ open: false, status: '', title: '' }); }} title={toast.title} />}
      </div>
    </>
  );
};

export default AuditTrail;
